import React from "react"

import PropTypes from "prop-types"
import {Button as SemanticButton, Icon as SemanticIcon} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"

import "./iconButton.scss"

export const ICON_BUTTON_VARIANTS = {
    DEFAULT: "default",
    ACTION: "action",
    ACTION_WARNING: "action-warning",
    ACTION_BIG: "action-big",
    DARK_BLUE_SQUARE: "dark-blue-square",
}

const IconButton = ({ariaLabel, dataTestId = undefined, icon, variant = ICON_BUTTON_VARIANTS.DEFAULT, ...props}) => (
    <SemanticButton
        aria-label={ariaLabel}
        className={`icon-button variant-${variant}`}
        data-testid={dataTestId || getDataTestId(icon, "bouton")}
        type="button"
        {...props}
    >
        <SemanticIcon aria-hidden="true" name={icon} />
    </SemanticButton>
)

IconButton.propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    dataTestId: PropTypes.string,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.oneOf(Object.values(ICON_BUTTON_VARIANTS)),
}

export default IconButton
